// extracted by mini-css-extract-plugin
module.exports = {"CompletedTask":"styles_CompletedTask__2onrp"};